// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2FbJH","disabled":"FileBtn_disabled__1p43y","warn":"FileBtn_warn__2XKuz","fade":"FileBtn_fade__3S6ug"};